import { toast } from "react-toastify";
import apiClient from "./api";

// Crée une personne à contacter
export const createPersonContact = async (personContactData) => {
  try {
    const response = await apiClient.post(
      `/api/PersonContact`,
      personContactData
    );
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la création de la personne à contacter :', error);
    if (error.response) {
      console.error('Données de réponse :', error.response.data);
      console.error('Statut :', error.response.status);
    }
    throw error;
  }
};

// Récupère tous les contacts pour un compte spécifique
export const getPersonContactsByAccount = async (accountId,domainId) => {
  try {
    const response = await apiClient.get(
      `/api/PersonContact/account/${accountId}/${domainId}`
    );
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des contacts par compte :', error);
    throw error;
  }
};

// Récupère tous les contacts pour un domaine
export const getAllPersonContactsByDomain = async (domainId) => {
  try {
    const response = await apiClient.get(
      `/api/PersonContact/all/${domainId}`
    );
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération de tous les contacts :', error);
    throw error;
  }
};

// Met à jour une personne à contacter existante
export const updatePersonContact = async (id, updatedData) => {
  try {
    const response = await apiClient.put(
      `/api/PersonContact/${id}`,
      updatedData
    );
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de la personne à contacter :', error);
    throw error;
  }
};

// Supprime une personne à contacter
export const deletePersonContact = async (id) => {
  try {
    const response = await apiClient.delete(
      `/api/PersonContact/${id}`
    );
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la suppression de la personne à contacter :', error);
    throw error;
  }
};

export const getPersonContactById = async (id) => {
    const response = await apiClient.get(`/api/PersonContact/${id}`);
    return response.data;
  };
  
